import { CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AutoUnsubscribe } from '../../auto-unsubscribe.decorator';
import { FormFieldAutoComponent } from '../../forms/form-field-auto/form-field-auto.component';
import { FormFieldTextComponent } from '../../forms/form-field-text/form-field-text.component';
import { ResizeObserverDirective } from '../../resize/resize-observer.directive';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@AutoUnsubscribe()
@Component({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    OverlayModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
    FormFieldAutoComponent,
    FormFieldTextComponent,
    ResizeObserverDirective,
    MatMenuTrigger,
    MatMenu,
  ],
  selector: 'app-table-filters',
  templateUrl: './table-filters.component.html',
  styleUrls: ['./table-filters.component.scss'],
  standalone: true,
})
export class TableFiltersComponent {
  @Input()
  expanded = false;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  field = 'filter';

  @Input()
  label = 'Filter';

  @Input()
  showMoreOptionsBtn = false;

  @Input()
  displayFn: (element: unknown) => string;

  @Input()
  listOptions: (args: string) => unknown[] | Promise<unknown[]> | Observable<unknown[]>;

  @Input()
  lazyLoad = false;

  @Input()
  compactModeOnActions = true;

  @Input()
  summary = '';

  @Input()
  actionsTemplateRef: TemplateRef<HTMLElement>;

  @Input()
  menuActionsTemplateRef: TemplateRef<HTMLElement>;

  @Output()
  clearSummary: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('trigger')
  tableFiltersExpandBtn: CdkOverlayOrigin;

  @ViewChild(FormFieldAutoComponent)
  private formFieldAutoComponent: FormFieldAutoComponent;

  @Input()
  minViewWidth = 480;

  compact = false;
  viewWidth = 5000;

  @Output()
  readonly componentResize: EventEmitter<ResizeObserverEntry> = new EventEmitter<ResizeObserverEntry>();

  componentResized(event: ResizeObserverEntry): void {
    this.viewWidth = event.contentRect.width;
    this.compact = this.viewWidth <= this.minViewWidth;
    this.componentResize.emit(event);
  }

  overlayKeydown(event: KeyboardEvent): void {
    if (event.code === 'Escape') {
      this.expanded = false;
    }
  }

  search(valueModifier?: (value: unknown) => unknown): void {
    this.formFieldAutoComponent.search(valueModifier);
  }
}
